(function () {
  function donation_added() {
    $(".prod--donate-remove").each(function () {
      var var_id = $(this).data("var-id");
      $(".product--donation-li").each(function () {
        if ($(this).data("li-varid") == var_id) {
          $(this).addClass("product--donation-added");
        }
      });
    });
  }

  function total_price_recalc(price_val, price_do) {
    var cpc_total = $(".cart-preview-footer .cart-preview-total-line span")
      .text()
      .substring(1);
    var cur_total =
      parseInt(cpc_total.replace(/\,/g, ""), 10) + parseInt(price_val);
    if (price_do == "remove") {
      cur_total =
        parseInt(cpc_total.replace(/\,/g, ""), 10) -
        parseInt(price_val.toString().replace(/\,/g, ""));
    } else {
      cur_total =
        parseInt(cpc_total.replace(/\,/g, ""), 10) + parseInt(price_val);
    }
    cur_total = cur_total.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    $(".cart-preview-footer .cart-preview-total-line span").text(
      "$" + cur_total
    );
  }

  // Remove Donation.
  $("body").on(
    "click",
    ".cart-preview-contents .prod--donate-remove",
    function () {
      var t_id = $(this).attr("data-var-id");
      $.post("/cart/change.js", { quantity: 0, id: t_id });
      total_price_recalc(
        $(this)
          .closest(".small")
          .siblings(".cart-preview-product__price")
          .text()
          .substring(1),
        "remove"
      );
      $(this).closest(".cart-preview-product").remove();
      $('.product--donation-li[data-li-varid="' + t_id + '"]').removeClass(
        "product--donation-added"
      );
    }
  );

  // added donate products
  $("body").on("click", ".product--donations .prod--donate-btn", function () {
    var elm = $(this);
    var elu = elm.siblings("a").attr("href");
    var elp = elm.attr("data-prod-id");
    const chk_variant = parseInt(elm.attr("data-var-id"));
    var elm_chk = false;
    $(".cart-preview-contents .cart-preview-product__image").each(function () {
      if ($(this).attr("href") == elu) {
        elm_chk = true;
      }
    });
    setTimeout(function () {
      //location.reload(true);
      if (elm_chk == false) {
        $.post("/cart/add.js", {
          quantity: 1,
          id: chk_variant,
        });
        var cpc_url = elm.siblings("a").attr("href");
        var cpc_text = elm.siblings("a").text();
        var cpc_img = elm.siblings("a").data("img-url");
        var cpc_price = elm.siblings("a").data("prod-price");
        $(".cart-preview-contents .cart-preview-body").before(
          '<div class="cart-preview-product"><a href="' +
            cpc_url +
            '" class="cart-preview-product__image"><img src="' +
            cpc_img +
            '" alt=""></a><div class="cart-preview-product__detail"><div class="cart-preview-product__price">' +
            cpc_price +
            '</div><a href="' +
            cpc_url +
            '" class="cart-preview-product__name">' +
            cpc_text +
            '</a><div class="small"><p><a href="#" class="prod--donate-remove" data-var-id="' +
            chk_variant +
            '">Remove</a></p></div></div></div>'
        );
        total_price_recalc(elm.siblings("a").data("prod-price1"), "add");
        elm
          .closest(".product--donation-li")
          .addClass("product--donation-added");
      }
    }, 250);
  });

  $("body").on("click", function (e) {
    if (
      e.target.id == "cart-preview-dropdown" ||
      e.target.id == "ajax-trigger" ||
      e.target.parentElement.id == "ajax-trigger" ||
      e.target.id == "add-to-cart" ||
      $(e.target).hasClass("header-mobile-cart") ||
      $(e.target).parent().hasClass("header-mobile-cart") ||
      $(e.target).hasClass("prod--donate-remove")
    )
      return;
    if ($(e.target).closest("#cart-preview-dropdown").length) {
      return;
    }

    $("#cart-preview-dropdown").removeClass("is-open");
  });

  $(".header-mobile-cart").on("click", function (e) {
    donation_added();
  });
})();
